import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import io from "socket.io-client";

import { CHAT_URL } from "@/Constants/common";
const initialState = {
  socket: null,
  socketConnected: false,
  socketError: null,
};

export const handleSocketConnection = createAsyncThunk(
  "socket/connectSocket",
  async (data, thunkAPI) => {
    const { user_id, user_type, user_token } = data;
    var socket_user_id = user_id;
    var socket_user_type = user_type;
    var socket_user_token = user_token;
    var options = {
      transports: ["websocket", "polling"],
      query: {
        user_id: socket_user_id,
        user_token: socket_user_token,
        user_type: socket_user_type,
      },
      secure: true,
      rejectUnauthorized: false, // for self-signed certificates
    };
    //   console.log("Connecting to socket server...",options);
    try {
      // console.log("Connecting to socket server...");
      const socket = io.connect(CHAT_URL, options);
      // console.log(socket);
      return thunkAPI.dispatch(setSocket(socket));
    } catch (error) {
      thunkAPI.dispatch(setSocketConnected(false));
      return rejectWithValue(error);
    }
  },
);

export const socketSlice = createSlice({
  name: "clientSocket",
  initialState,
  reducers: {
    setSocket: (state, action) => {
      state.socket = action.payload;
      state.socketConnected = true;
    },
    setSocketConnected: (state, action) => {
      state.socketConnected = action.payload;
    },
    setSocketError: (state, action) => {
      state.socketError = action.payload;
    },
  },
});

export const { setSocket, setSocketConnected, setSocketError } =
  socketSlice.actions;

export default socketSlice.reducer;
